import * as PropTypes from 'prop-types';
import * as React from 'react';

class TogglableDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
    };
  }

  onSelectChange(event) {
    this.setState({ isEditing: false });
    this.props.onChange(event.target.value);
  }

  canChangeOption() {
    return this.props.selectOptions.length > 1;
  }

  changeOptionLink() {
    if (!this.canChangeOption()) {
      return false;
    }

    return (
      <a onClick={() => this.setState({ isEditing: true })}>
        {this.props.changeLinkText}
      </a>
    );
  }

  optionsForSelect() {
    return (
      this.props.selectOptions.map(option =>
        (<option
          key={option.value}
          value={option.value}
        >
          {option.name}
        </option>))
    );
  }

  optionLabel() {
    return (
      <label>
        {this.props.labelTitle}
      </label>
    );
  }

  nameForDefaultValue() {
    const defaultValue = this.props.selectOptions.find(option => option.value === this.props.defaultValue);

    return defaultValue.name;
  }

  optionSelector() {
    return (
      <div>
        {this.optionLabel()}
        <select
          name={this.props.inputName}
          className="required nochosen"
          type="text"
          autoComplete={this.props.autoComplete}
          defaultValue={this.props.defaultValue}
          onChange={event => this.onSelectChange(event)}
        >
          {this.optionsForSelect()}
        </select>
      </div>
    );
  }

  defaultValueHiddenInput() {
    return (
      <div>
        {this.optionLabel()}
        <input
          type="hidden"
          name={this.props.inputName}
          value={this.props.defaultValue}
        />
        <div>
          {this.nameForDefaultValue()} {this.changeOptionLink()}
        </div>
      </div>
    );
  }

  render() {
    if (this.state.isEditing) {
      return this.optionSelector();
    }

    return this.defaultValueHiddenInput();
  }
}

TogglableDropdown.propTypes = {
  autoComplete: PropTypes.string.isRequired,
  changeLinkText: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  selectOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTitle: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
};

export default TogglableDropdown;



// WEBPACK FOOTER //
// ./javascripts/components/shared/togglable_dropdown.jsx